<template>
	<div class="active-filters">
		<FilterPill
			v-for="filter in filters.list"
			:key="filter.id"
			:controls
			:filter
			:filters
			@updated="emit('updated')" />
	</div>
</template>

<script setup lang="ts">
import FilterPill from './FilterPill.vue'
import type { Filters } from '@/helpers/filters/Filters'
import type { FilterControls } from '@/helpers/filters/FilterControls'

defineProps<{ filters: Filters<any>; controls: FilterControls<any> }>()

const emit = defineEmits<{
	(e: 'updated'): void
}>()
</script>

<style scoped lang="scss">
.active-filters {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}
</style>
